
import FootNav from '../../components/FootNav.vue'
import Box from 'vux/src/components/box/index.vue'

import Card from 'vux/src/components/card/index.vue'

import Divider from 'vux/src/components/divider/index.vue'

import Group from 'vux/src/components/group/index.vue'
import Panel from 'vux/src/components/panel/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Drawer from 'vux/src/components/drawer/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'

import InfiniteLoading from 'vue-infinite-loading';

export default {
props: ['cateId'],
components: {
Group,
Panel,
Swiper,
Grid,
GridItem,
FootNav,
Box,
Card,
Divider,
InfiniteLoading,
Radio,
Drawer,
ViewBox,
XHeader
},
data() {
return {
swiperList: [],
categoryList: [],
page: 1,
loadFlag: true,
drawLeftList: [],
cateType: 'all',
drawerVisibility: false,
showMode: 'push',
showModeValue: 'push',
showPlacement: 'left',
showPlacementValue: 'left',
list: [],
cateName:''
}
},
watch: {
'$route'(to, from) { //直接刷新页面， 不会触发route监控
this.page = 1;
this.list=[];
this.$refs.infiniteLoading.$emit('infinite');
},
},
created: function () {
document.title='天一互联'
this.ajaxGetDetailInitData();
},
methods: {
ajaxGetDetailInitData() {
const url = this.tianYiWebUrl + '/wechat/news/ajaxGetDetailInitData';

this.$http.get(url).then(r => {
if (r.data.code === 200) {

let swiperListOrigin = r.data.data.topSwiper;
for (let x in swiperListOrigin) {
swiperListOrigin[x].img = this.tianYiWebUrl + swiperListOrigin[x].img
swiperListOrigin[x].url = '/news/' + swiperListOrigin[x].id
}
this.swiperList = swiperListOrigin;
this.categoryList = r.data.data.categoryList
} else {
}
})
},
getList($state) {
const url = this.tianYiWebUrl + '/wechat/news/getTopList';

this.$http.get(url, {params: {type: this.cateId, page: this.page}}).then(res => {
if (res.data.code === 200) {
let vRes = res.data.data;
this.cateName = res.data.cateName;
for (let x in vRes.data) {
vRes.data[x].src = this.tianYiWebUrl + vRes.data[x].src
vRes.data[x].url = '/news/' + vRes.data[x].id
}
this.list = [...this.list, ...vRes.data];
if (vRes.total > (vRes.per_page * vRes.current_page)) {
this.page++;
$state.loaded();
} else {
$state.complete();
}
}
})
},
infiniteHandler($state) {
this.getList($state);
},
}
}



// WEBPACK FOOTER //
// ./src/components/news/CateIndex.vue